import { Box, Button, Dialog, IconButton, Typography } from '@mui/material'
import { Dismiss24Regular, Pin20Regular } from '@/components/Icon'
import styles from './PinLimitDialog.module.scss'

export default function PinLimitDialog({ open, onClose, maxPins = 10 }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      aria-labelledby="pin-limit-dialog-title"
      aria-describedby="pin-limit-dialog-description"
      slotProps={{
        paper: { className: styles.dialogPaper, elevation: 0 },
      }}
    >
      <header className={styles.header}>
        <Box className={styles.titleRow}>
          <Box component="span" className={styles.titleIcon} aria-hidden>
            <Pin20Regular />
          </Box>
          <Typography id="pin-limit-dialog-title" component="h2" className={styles.title}>
            Pin limit reached
          </Typography>
        </Box>
        <IconButton
          type="button"
          aria-label="Close pin limit dialog"
          onClick={onClose}
          size="small"
          className={styles.closeButton}
        >
          <Dismiss24Regular className={styles.closeIcon} aria-hidden />
        </IconButton>
      </header>
      <Box className={styles.body}>
        <Typography id="pin-limit-dialog-description" component="p" className={styles.message}>
          You can pin up to {maxPins} threads. Unpin one to add another.
        </Typography>
        <Box className={styles.actions}>
          <Button type="button" variant="contained" size="small" onClick={onClose} className={styles.okButton}>
            Got it
          </Button>
        </Box>
      </Box>
    </Dialog>
  )
}
